/**
 * printUtil.js — механика окна печати. БЕЗ ЕДИНОГО ИМПОРТА — сознательно:
 * файл с нулём импортов можно запустить под заглушкой DOM и проверить
 * НАСТОЯЩИЙ код (приём Андрея из dropdown_test для htmlInit.js).
 *
 * Порядок: window.open → записать HTML → print; если открыть окно не дали
 * (блокировщик всплывающих) — скрытый iframe с тем же HTML.
 */

/**
 * Открыть окно печати с готовым HTML.
 * @param {string} html полный документ
 * @param {Window} [wnd] окно-хозяин (в тестах — заглушка; по умолчанию window)
 * @returns {'window'|'iframe'|'none'} какой путь сработал
 */
export function openPrintWindow(html, wnd) {
  const W = wnd || (typeof window !== 'undefined' ? window : null);
  if (!W || !W.document) return 'none';
  try {
    const w = W.open('', '_blank');
    if (w && w.document) {
      w.document.write(html);
      w.document.close();
      w.focus && w.focus();
      W.setTimeout(() => { try { w.print(); } catch (e) { /* печать отменена */ } }, 250);
      return 'window';
    }
  } catch (e) { /* всплывающие запрещены — идём в iframe */ }
  return _printViaIframe(html, W) ? 'iframe' : 'none';
}

function _printViaIframe(html, W) {
  try {
    const doc = W.document;
    const f = doc.createElement('iframe');
    f.style.cssText = 'position:fixed;right:0;bottom:0;width:0;height:0;border:0';
    doc.body.appendChild(f);
    const d = f.contentWindow.document;
    d.open(); d.write(html); d.close();
    W.setTimeout(() => {
      try { f.contentWindow.focus(); f.contentWindow.print(); } catch (e) { /* */ }
      W.setTimeout(() => { try { f.remove(); } catch (e) { /* */ } }, 1000);
    }, 300);
    return true;
  } catch (e) { return false; }
}

export default { openPrintWindow };
